import { cva } from '@/styled-system/css';

export const upsellRootRecipe = cva({
  base: {
    display: 'flex',
    rowGap: 'Upsell.Root.gap.icon-toText',
    columnGap: 'Upsell.Root.gap.img-toText',
    borderRadius: 'Upsell.Root',
    borderWidth: 'Upsell.Root',
    borderStyle: 'solid',
    paddingBlock: 'Upsell.Root.padding.vert',
    paddingInline: 'Upsell.Root.padding.horz',
    position: 'relative',
  },
  variants: {
    tone: {
      neutral: {
        backgroundColor: 'Upsell.Root.neutral.bg',
        borderColor: 'Upsell.Root.neutral.border',
      },
      soft: {
        backgroundColor: 'Upsell.Root.soft.bg',
        borderColor: 'Upsell.Root.soft.border',
      },
      hero: {
        backgroundColor: 'Upsell.Root.hero.bg',
        borderColor: 'Upsell.Root.hero.border',
      },
      impact: {
        backgroundColor: 'Upsell.Root.impact.bg',
        borderColor: 'Upsell.Root.impact.border',
      },
    },
    elevated: {
      true: {
        boxShadow: 'Upsell.Root',
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      tone: 'neutral',
      elevated: true,
      css: {
        backgroundColor: 'Upsell.Root.neutral.elevated.bg',
        borderColor: 'Upsell.Root.neutral.elevated.border',
      },
    },
  ],
});
